<template>
    <v-card>
      <v-toolbar dense flat dark :color="toolbarColor">
        <v-toolbar-title>
          <span class="font-weight-light body-2" v-html="getExpression('FormTitle', 'MessageType')">
          </span>
        </v-toolbar-title>
  
        <v-spacer />
  
        <v-toolbar-items>
          <v-btn @click="close()" small fab :color="toolbarColorDark" class="elevation-0">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
  
      <v-list-item-group>
  
        <v-list-item @click="close('audio')">
          <v-list-item-avatar>
            <v-icon>audiotrack</v-icon>
          </v-list-item-avatar>
  
          <v-list-item-title>
            {{ getExpression('MenuItem', 'Audio') }}
          </v-list-item-title>
        </v-list-item>
  
        <v-divider />

        <v-list-item @click="close('image')">
          <v-list-item-avatar>
            <v-icon>photo</v-icon>
          </v-list-item-avatar>
  
          <v-list-item-title>
            {{ getExpression('MenuItem', 'Image') }}
          </v-list-item-title>
        </v-list-item>

        <v-divider />
  
        <v-divider />

        <v-list-item @click="close('video')">
          <v-list-item-avatar>
            <v-icon>movie</v-icon>
          </v-list-item-avatar>
  
          <v-list-item-title>
            {{ getExpression('MenuItem', 'Video') }}
          </v-list-item-title>
        </v-list-item>

        <v-divider />
        
        <v-list-item @click="close('text')">
          <v-list-item-avatar>
            <v-icon>subject</v-icon>
          </v-list-item-avatar>
  
          <v-list-item-title>
            {{ getExpression('MenuItem', 'Text') }}
          </v-list-item-title>
        </v-list-item>
      </v-list-item-group>
    </v-card>
  </template>
  
  <script>
  import { AppColor } from '@/config.js'
  
  export default {
    name: 'MessageTypeSelector',
    props: {
      toolbarColor: {
        type: String,
        default: AppColor.Medium
      },
      toolbarColorDark: {
        type: String,
        default: AppColor.Dark
      }
    },
    methods: {
      close (messageType) {
        this.$emit('close', messageType)
      }
    }
  }
  </script>